import * as ko from 'knockout';

import { localizedString } from '@pressreader/resources';
import { httpPost } from '@pressreader/services';

import ndAlert from 'nd.alert';
import { DialogStatus } from 'nd.ui.dialogstatus';
import { logError } from 'shared/errors/error.handlers';

interface AuthorizeArgs {
    provider: string;
}

interface XAuthResponse {
    Status: number;
}

function showError(): void {
    ndAlert().show(localizedString('Errors.SignInFailed'));
}

class InstapaperAuthProvider {
    async authorize({ provider }: AuthorizeArgs): Promise<boolean> {
        const dialog = (await import('nd.ui.dialog')).default;
        return new Promise<boolean>((resolve, reject) => {
            const parentDialog = dialog.getParent();
            const signInDialog = dialog.createInstance();

            signInDialog.onHide((_: unknown, result: { status?: DialogStatus } | undefined) => {
                if (result && result.status === DialogStatus.Ok) {
                    if (parentDialog) {
                        parentDialog.hide();
                    }
                    resolve(true);
                } else {
                    if (parentDialog) {
                        parentDialog.restore();
                    }
                    reject();
                }
            });

            const viewModel = {
                userName: ko.observable<string>(),
                password: ko.observable<string>(),
                submit: () => {
                    const post = { provider, userName: viewModel.userName(), password: viewModel.password() };
                    httpPost<XAuthResponse>('externalauth', 'AuthorizeXAuth', post)
                        .then(response => {
                            if (response && response.Status === 0) {
                                signInDialog.hide(DialogStatus.Ok);
                            } else {
                                showError();
                            }
                        })
                        .catch(logError);
                },
                close: () => signInDialog.hide(DialogStatus.Close),
            };

            signInDialog.show({
                templateName: 'v7.Client.Dialogs.xAuth.Signin',
                model: viewModel,
            });
        });
    }
}

export default InstapaperAuthProvider;
